import React, { createContext, useContext, type ReactNode } from 'react'
import { useGooglePhotos } from '../useGooglePhotos'
import type { UseGooglePhotosReturn } from '../GooglePhotosPicker.types'

const GooglePhotosContext = createContext<UseGooglePhotosReturn | null>(null)

export function useGooglePhotosContext(): UseGooglePhotosReturn {
  const context = useContext(GooglePhotosContext)
  if (!context) {
    throw new Error(
      'useGooglePhotosContext must be used within a GooglePhotosProvider'
    )
  }
  return context
}

export function GooglePhotosProvider({ children }: { children: ReactNode }) {
  const googlePhotosValue = useGooglePhotos()

  return (
    <GooglePhotosContext.Provider value={googlePhotosValue}>
      {children}
    </GooglePhotosContext.Provider>
  )
}
